import styled from 'styled-components';

import { useVenueTag } from '../../../tag-manager/venue';
import Pagination from './Pagination';
import Venue from './Venue';
import VenueSmall from './VenueSmall';

export const Venues = styled.ul`
  margin: 0;
  padding: 0;
`;

// A <ul> may hold only <li>. The bullet a <li> carries by default is drawn
// OUTSIDE the list's content box, and ListWrapper leaves 44px of padding for
// it to sit in, so it would be visible beside every card. list-style: none.
export const VenueItem = styled.li`
  list-style: none;
`;

const ListView = ({ venueList, selected, setSelectedVenue, totalPages, currentPage, setCurrentPage, isHostView = false }) => (
  <>
    <Venues>
      {venueList.map((venue) => (
        <VenueItem key={venue.id}>
          {isHostView ? (
            <VenueSmall venue={venue} selected={selected} setSelectedVenue={setSelectedVenue} />
          ) : (
            <Venue
              venue={venue}
              selected={selected}
              setSelectedVenue={setSelectedVenue}
              onClick={() => useVenueTag({ venueId: venue.id, label: venue.name || 'Unknown Venue' })}
            />
          )}
        </VenueItem>
      ))}
    </Venues>
    <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
  </>
);

export default ListView;
